import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fetchExportBinary } from '../exportsActions';
import { getFetchExportCsvUrl } from '../exportsEntity';
import { connect } from 'react-redux';
import { EmvioButton as Button } from '@nexio/emvio-form-components';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import './Actions.scss';
import * as _ from 'lodash';

export class Actions extends Component {
    static propTypes = {
        record: PropTypes.shape({
            reportName: PropTypes.string,
            dateCreated: PropTypes.string,
            status: PropTypes.string,
            expiration: PropTypes.string,
            action: PropTypes.string,
            guid: PropTypes.string
        }),
        onFetchBinary: PropTypes.func.isRequired,
        fetchUrl: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.handleOnClick = this.handleOnClick.bind(this);
    }

    handleOnClick() {
        this.props.onFetchBinary(this.props.record);
    }

    componentDidUpdate(previousProps) {
        if (doesPropExistAndHasItChanged(previousProps, this.props, 'fetchUrl')) {
            window.location = this.props.fetchUrl;
        }
    }

    isDownloadAggregated(){

        return _.get(this.props.record, 'aggregated');
    }

    renderMessage() {
        const failed = _.get(this.props.record, 'failed');
        const aggregated = _.get(this.props.record, 'aggregated');

        let message = 'Please Wait';

        if (failed) {
            message = 'Failed';
        } else if (aggregated) {
            message = 'Download';
        }

        return message;
    }

    render() {
        return (
            <div className="emvio-export-actions">
                <Button className="exports-available-download-button-centered"
                    disabled={!this.isDownloadAggregated()}
                    type="button"
                    title="download"
                    size="small"
                    invertColors={true}
                    onClick={this.handleOnClick}
                    shouldHaveTooltip={false}
                >
                    {this.renderMessage()}
                </Button>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        fetchUrl: getFetchExportCsvUrl(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onFetchBinary: (record) => dispatch(fetchExportBinary(record))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Actions);
